import { html } from "lit";

export default html`
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
    <path
      fill="currentColor"
      d="M12 8.487a.6.6 0 0 1 .6.6v4.872a.6.6 0 0 1-1.2 0V9.087a.6.6 0 0 1 .6-.6Zm-.85 8.395c0-.47.38-.85.85-.85h.01a.85.85 0 1 1 0 1.7H12a.85.85 0 0 1-.85-.85Z"
    />
    <path
      fill="currentColor"
      fill-rule="evenodd"
      d="M12.64 2.286a1.574 1.574 0 0 0-1.28 0c-.295.131-.5.368-.665.6-.162.23-.34.537-.549.898L2.103 17.677c-.21.362-.388.67-.507.926-.12.26-.223.556-.19.878.047.444.28.847.64 1.11.262.19.57.25.855.275.282.026.637.026 1.056.026h16.086c.419 0 .774 0 1.056-.026.284-.026.593-.084.854-.275.361-.263.594-.666.64-1.11.034-.322-.07-.618-.19-.878a12.493 12.493 0 0 0-.506-.927L13.854 3.784c-.21-.361-.387-.668-.55-.897-.165-.233-.37-.47-.665-.601Zm-.792 1.096a.374.374 0 0 1 .304 0c.003.002.055.032.173.198.127.18.277.438.505.83l8.014 13.843c.228.394.377.654.47.854.086.186.086.246.086.25a.374.374 0 0 1-.152.263c-.003.002-.056.033-.26.051-.219.02-.519.021-.974.021H3.986c-.455 0-.755 0-.975-.02-.21-.02-.259-.052-.259-.052a.374.374 0 0 1-.152-.263c0-.004 0-.065.086-.25.092-.2.242-.46.47-.854L11.17 4.41c.227-.393.378-.651.505-.83.122-.173.173-.199.173-.199Z"
      clip-rule="evenodd"
    />
  </svg>
`;
